import { useI18n } from '../hooks';

import Popup from './Popup';
import { useState } from 'react';

const SiteNotOpening: React.FC = () => {
	const homePageText = useI18n(i18n => i18n.homePageText);
	const close = useI18n(i18n => i18n.am.close);

	const [popupOpen, setPopupOpen] = useState<boolean>(true)

	return (
		<>
			<Popup
				open={popupOpen}
				text={
					<div className='centered-not-opening-text'>
						{homePageText.siteNotOpening}
						<br />
						{homePageText.willReturnNextYear}
					</div>
				}
				buttons={[{ text: close, onClick: () => setPopupOpen(false), variant: 'green' }]} />

		</>
	);
}

export default SiteNotOpening;
